// import { configureStore } from "@reduxjs/toolkit";

// import userReducer from '../features/user/userSlice';
// import testReducer from '../features/tests/testSlice';


// export const store =configureStore({
//     reducer:{
//        auth:userReducer,
//         tests:testReducer
//     }
// })


// export default store;



import { configureStore ,combineReducers } from "@reduxjs/toolkit";

import userReducer from '../features/user/userSlice';
import testReducer from '../features/tests/testSlice';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from "redux-persist";

import storage from "redux-persist/lib/storage"; // defaults to localStorage for web


// Create root reducer
const rootReducer = combineReducers({
  auth: userReducer,
  tests: testReducer
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: []
};


// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);



// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Required for redux-persist
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    })
});

// Create persistor
export const persistor = persistStore(store);

export default store;